export default "__VITE_ASSET__Da5$aShe__"